import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 6.45817V5.06928M10 6.45817H8.61111C7.07699 6.45817 5.83333 5.21452 5.83333 3.68039C5.83333 2.91333 6.45516 2.2915 7.22222 2.2915C8.75635 2.2915 10 3.53516 10 5.06928M10 6.45817H11.3889C12.923 6.45817 14.1667 5.21452 14.1667 3.68039C14.1667 2.91333 13.5448 2.2915 12.7778 2.2915C11.2437 2.2915 10 3.53516 10 5.06928M10 6.45817H4.79167C3.87119 6.45817 3.125 7.20436 3.125 8.12484V8.33317C3.125 8.95007 3.46017 9.48869 3.95833 9.77687M10 6.45817H15.2083C16.1288 6.45817 16.875 7.20436 16.875 8.12484V8.33317C16.875 8.95007 16.5398 9.48869 16.0417 9.77687M10 6.45817V9.99984M10 16.8748H5.625C4.70453 16.8748 3.95833 16.1286 3.95833 15.2082V9.77687M10 16.8748H14.375C15.2955 16.8748 16.0417 16.1286 16.0417 15.2082V9.77687M10 16.8748V9.99984M10 9.99984H15.2083C15.5119 9.99984 15.7965 9.91868 16.0417 9.77687M10 9.99984H4.79167C4.48809 9.99984 4.20348 9.91867 3.95833 9.77687M3.95833 9.58317V9.77687M16.0417 9.77687V9.58317",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }